var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "event-agent-header" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("agentEntryForm.title")))]),
        _c("div", { staticClass: "button-wrapper" }, [
          _c(
            "button",
            {
              staticClass: "next",
              attrs: { disabled: _vm.selectedNovelIds.length === 0 },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("agentEntryForm.submitButton")))]
          ),
        ]),
      ]),
      _vm.targetNovels.length === 0
        ? [
            _c("div", { staticClass: "novel-empty" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("agentEntryForm.emptyTitle"))),
              ]),
              _c("div", { staticClass: "message" }, [
                _vm._v(_vm._s(_vm.$t("agentEntryForm.emptyMessage"))),
              ]),
            ]),
          ]
        : [
            _c(
              "div",
              { staticClass: "novel-list" },
              _vm._l(_vm.targetNovels, function (novel) {
                return _c("AgentCampaignNovelListItem", {
                  key: novel.novelId,
                  attrs: {
                    campaignId: _vm.$route.params.campaignId,
                    novel: novel,
                    selectedNovelIds: _vm.selectedNovelIds,
                  },
                  on: {
                    input: function ($event) {
                      _vm.selectedNovelIds = $event
                    },
                  },
                })
              }),
              1
            ),
          ],
      _vm.loading ? _c("MaskedLoading", { staticClass: "loading" }) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }